import { motion } from "framer-motion";
import {CheckCircle2, XCircle} from 'lucide-react';

const qualifications = [
"Já tentou aprender inglês antes",
"Sente que está travado no básico",
"Quer melhorar para trabalho, faculdade ou viagens",
"Quer resultado real, não distração"];


export default function ForWhoSection() {
  return (
    <section className="bg-gray-50 md:py-20 pt-[40px] pb-[40px]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="font-serif-display text-3xl md:text-4xl font-bold text-blue-900 text-center mb-10">

          Esse plano é para você que:
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
          {qualifications.map((q, i) =>
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: i * 0.1 }}
            className="flex items-start gap-3 bg-white rounded-xl p-5 shadow-sm border border-green-100">

              <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" />
              <p className="text-gray-800 font-medium text-lg">{q}</p>
            </motion.div>
          )}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4 }}
          className="bg-red-50 rounded-2xl p-6 border border-red-100 text-center">

          <div className="flex items-center justify-center gap-2 mb-2">
            <XCircle className="w-5 h-5 text-red-500" />
            <p className="text-red-700 font-semibold">
              Não é para quem quer só "dar uma olhadinha".
            </p>
          </div>
          <p className="text-blue-900 font-bold text-lg">
            É para quem decidiu avançar.
          </p>
        </motion.div>
      </div>
    </section>);

}